<template>
  <div v-if="outputDataItem">
    <v-menu transition="slide-x-transition" bottom right>
      <template v-slot:activator="{ on }">
        <v-btn color="transparent" v-on="on" @click="fetchHomeModalData">
          <v-img
            v-if="outputDataItem.image"
            :src="require(`../../assets/images/icons/${outputDataItem.image}`)"
            contain
            width="32"
            height="32"
          ></v-img>
          <span class="pt-2">
            {{ outputDataItem.val }}
            <span class="pt-2" v-if="outputDataItem.unit">
              {{ outputDataItem.unit }}
            </span>
          </span>
        </v-btn>
      </template>

      <v-list v-if="outputDataList" class="menu-block">
        <v-list-tile>
          <v-list-tile-title>
            {{ outputDataList.title | translate }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-for="(item, i) in outputDataList.rows" :key="i">
          <span v-if="item.label">{{ item.label | translate }}</span>
          <span v-if="item.value"
            >{{ item.value }}
            <span v-if="item.unit"> {{ item.unit | translate }}</span>
          </span>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalService from "../../services/global-service.js";

export default {
  name: "HomeInfoModals",
  data() {
    return {
      outputDataItem: undefined,
      propertyName: undefined,
      outputDataList: undefined
    };
  },
  props: {
    outputData: {
      type: Object,
      default: () => {}
    },
    property: {
      type: String,
      default: ""
    },
    apiParam: {
      type: String,
      default: ""
    }
  },
  watch: {
    outputData: function(newVal) {
      this.outputDataItem = newVal;
    }
  },
  mounted() {
    this.outputDataItem = this.outputData;
    this.propertyName = this.property;
  },
  computed: {
    ...mapGetters("user", ["getUser"])
  },
  methods: {
    async fetchHomeModalData() {
      let outputIndex = this.propertyName.split("-")[1];
      this.outputDataList = await GlobalService.getHomeModalData(
        `${this.apiParam}=${outputIndex}`,
        this.getUser.token
      );
    }
  }
};
</script>
<style>
.menu-block {
  padding: 0;
  min-width: 256px;
}
.menu-block > div:first-child {
  background: #be414e;
  color: #fff;
  padding: 0 0 0 10px;
  line-height: 48px;
}
.menu-block span {
  font-size: 12px;
  letter-spacing: 0.02em;
  flex: 1;
}
.menu-block span:last-child {
  -webkit-flex: 1 1 30%;
  -ms-flex: 1 1 30%;
  flex: 1 1 30%;
  max-width: 30%;
  max-height: 100%;
  box-sizing: border-box;
}
</style>
